export default theme => ({
    wrapper: {
        display: 'flex',
        minHeight: '100vh'
    },
    vervoeLogo: {
        position: 'fixed',
        left: 40,
        top: 23,
        zIndex: 101
    },
    banner: {
        display: 'none',
        backgroundColor: '#fff',
        zIndex: 100,
        top: 0,
        left: 0,
        position: 'fixed',
        width: 'calc(100% - 600px)',
        height: 65,
        [theme.breakpoints.down('lg')]: {
            width: 'calc(100% - 20px)'
        },
        '@media only screen and (min-width: 1280px) and (max-width: 1420px)': {
            display: 'block'
        },
        '@media only screen and (max-width: 820px)': {
            display: 'block'
        }
    },
    main: {
        flexGrow: 1,
        backgroundColor: '#fff',
        padding: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('lg')]: {
            padding: 48
        }
    },
    content: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
            maxWidth: 430
        }
    },
    sidebar: {
        userSelect: 'none',
        display: 'flex',
        alignItems: 'center',
        width: 580,
        padding: '50px 69px',
        color: '#fff',
        backgroundColor: theme.palette.blue[900],
        [theme.breakpoints.down('lg')]: {
            display: 'none'
        }
    },
    header: {
        marginTop: 55,
        marginBottom: 40,
        fontWeight: 800,
        fontSize: 24
    },
    features: {
        columnCount: 2
    },
    feature: {
        fontSize: 14,
        fontWeight: 700,
        marginBottom: 15
    },
    img: {
        display: 'block',
        margin: '0 auto',
        '@media only screen and (max-height: 680px)': {
            display: 'none'
        }
    }
});
